import { Link } from "react-router-dom";
import { Linkedin, Mail, Phone, MapPin } from "lucide-react";
import Logo from "@/components/Logo";
import Tagline from "@/components/Tagline";

export default function Footer() {
  return (
    <footer className="bg-[#070707] border-t border-[#161616] relative z-10" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <Logo size="sm" asLink={false} dataTestId="footer-logo" />
          <p className="mt-6 text-white/65 text-sm max-w-md leading-relaxed">
            Un unico interlocutore per la tua attività. Consulenza multidisciplinare
            per microimprese, PMI e privati in Campania e in tutta Italia.
          </p>
          <Tagline className="mt-4" size="text-sm" testId="footer-tagline" />
        </div>

        <div>
          <p className="eyebrow mb-4">Navigazione</p>
          <ul className="space-y-1 text-sm">
            <li><Link to="/" className="tap-target text-white/75 hover:text-[#FACC15] transition-colors" data-testid="footer-link-home">Home</Link></li>
            <li><Link to="/chi-siamo" className="tap-target text-white/75 hover:text-[#FACC15] transition-colors" data-testid="footer-link-chi-siamo">Chi siamo</Link></li>
            <li><Link to="/servizi" className="tap-target text-white/75 hover:text-[#FACC15] transition-colors" data-testid="footer-link-servizi">Servizi</Link></li>
            <li><Link to="/blog" className="tap-target text-white/75 hover:text-[#FACC15] transition-colors" data-testid="footer-link-esperto">L'esperto risponde</Link></li>
            <li><Link to="/lavora-con-noi" className="tap-target text-white/75 hover:text-[#FACC15] transition-colors" data-testid="footer-link-lavora">Lavora con noi</Link></li>
            <li><Link to="/privacy-policy" className="tap-target text-white/75 hover:text-[#FACC15] transition-colors" data-testid="footer-link-privacy">Privacy policy</Link></li>
            <li><Link to="/contatti" className="tap-target text-white/75 hover:text-[#FACC15] transition-colors" data-testid="footer-link-contatti">Contatti</Link></li>
          </ul>
        </div>

        <div>
          <p className="eyebrow mb-4">Contatti</p>
          <ul className="space-y-3 text-sm text-white/75">
            <li className="flex items-start gap-2">
              <Mail size={15} className="mt-0.5 text-[#FACC15]" />
              <a href="mailto:info@idea-360.it" className="tap-target hover:text-[#FACC15] transition-colors" data-testid="footer-email">
                info@idea-360.it
              </a>
            </li>
            <li className="flex items-start gap-2">
              <Phone size={15} className="mt-0.5 text-[#FACC15]" />
              <a href="tel:+393773473022" className="tap-target hover:text-[#FACC15] transition-colors" data-testid="footer-phone">
                +39 377 347 3022
              </a>
            </li>
            <li className="flex items-start gap-2">
              <MapPin size={15} className="mt-0.5 text-[#FACC15]" />
              <span>Campania, Italia</span>
            </li>
            <li className="pt-2">
              <a
                href="https://www.linkedin.com/company/idea360consulting"
                target="_blank"
                rel="noopener noreferrer"
                className="tap-target gap-2 text-white/75 hover:text-[#FACC15] transition-colors"
                data-testid="footer-linkedin"
              >
                <Linkedin size={15} className="text-[#FACC15]" />
                LinkedIn
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-[#161616]">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6 flex flex-col sm:flex-row justify-between gap-3 text-xs text-white/45">
          <p>© {new Date().getFullYear()} Idea 360 Consulting. Tutti i diritti riservati.</p>
          <p className="hidden" data-testid="footer-piva">P.IVA —</p>
        </div>
      </div>
    </footer>
  );
}
